import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { LocalizationService } from './service/localization.service';
import { Locale } from './data/type/locale';
import { getLocaleFromPath } from './utils/pathname';
import { DOCUMENT } from '@angular/common';
import { environment } from 'src/environments/environment';
import { Meta } from '@angular/platform-browser';
import { ProgressService } from './service/progress.service';
import { RotationService } from './service/rotation.service';
import isMobile from '../app/utils/is-mobile';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  public isLocalizationLoading: boolean = true;
  public vh: number = 0;
  public isComparisonWindowOpen = false;

  constructor(
    private localizationService: LocalizationService,
    private progressService: ProgressService,
    private rotationService: RotationService,
    private renderer: Renderer2,
    private meta: Meta,
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.rotationService.addResizeEventListener();
  }

  private loadAnalyticsScripts = () => {
    const gtmScriptLink = this.renderer.createElement('script');
    gtmScriptLink.async = true;
    gtmScriptLink.src = `https://www.googletagmanager.com/gtag/js?id=${environment.googleAnalyticsId}`;
    this.renderer.appendChild(this.document.body, gtmScriptLink);

    const gtagScript = this.renderer.createElement('script');
    gtagScript.type = 'text/javascript';
    gtagScript.async = true;
    gtagScript.text = `
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          dataLayer.push(arguments);
        }
        gtag('js', new Date());
    `;
    this.renderer.appendChild(this.document.body, gtagScript);

    const consentBarScript = this.renderer.createElement('script');
    consentBarScript.defer = true;
    consentBarScript.setAttribute('data-autoload-cookie-consent-bar', 'true');
    consentBarScript.setAttribute(
      'data-autoload-cookie-consent-bar-intl-code',
      getLocaleFromPath(),
    );
    consentBarScript.src =
      'https://www.gstatic.com/brandstudio/kato/cookie_choice_component/cookie_consent_bar.v3.js';

    this.renderer.appendChild(this.document.body, consentBarScript);
  };

  private setOGImageMetadata = () => {
    this.meta.addTag({
      property: 'og:image',
      content: `${location.origin}/assets/images/Google-Chromecast-with-Google-TV-OG.jpg`,
    });
  };

  private setDeviceAttribute = () =>
    this.document.children[0].setAttribute('device', isMobile() ? 'mobile' : 'desktop');

  ngOnInit(): void {
    // Add device attr to set styles depending on device
    this.setDeviceAttribute();

    window.addEventListener('resize', this.setDeviceAttribute);

    if (environment.production) {
      this.loadAnalyticsScripts();
    }

    this.setOGImageMetadata();
    const locale = getLocaleFromPath();

    this.progressService.comparisonButtonClick$.subscribe(
      (hasComparisonButtonBeenClicked: boolean) => {
        this.isComparisonWindowOpen = hasComparisonButtonBeenClicked;
      },
    );

    if (!locale || !Locale[locale]) {
      location.href = `${location.protocol}//${location.host}${
        environment.baseHref ? `${environment.baseHref}/` : '/'
      }${Locale['en-us']}${window.location.search}`;
    } else {
      this.localizationService.getLocalizedCopy(locale);
      this.localizationService.translationLoaded$.subscribe((hasLoaded: boolean) => {
        this.isLocalizationLoading = !hasLoaded;
        this.localizationService.translationLoaded$.unsubscribe();
      });
    }
  }
}
